import { render, staticRenderFns } from "./PointStatistics.vue?vue&type=template&id=52e9ae8a&scoped=true"
import script from "./PointStatistics.vue?vue&type=script&lang=js"
export * from "./PointStatistics.vue?vue&type=script&lang=js"
import style0 from "./PointStatistics.vue?vue&type=style&index=0&id=52e9ae8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9ae8a",
  null
  
)

export default component.exports